<template>
    <div class="filters app-phone-flex-column app-phone-full-width">
        <div class="school-dropdown-container app-phone-full-width">
            <menu-dropdown
                id="chooseSchoolDropdown"
                cssClass="app-print-hide"
                :value="$store.state.PublicMenuModule.siteID"
                :change="onSiteChange"
                :dataSource="sites"
                :fields="{text: 'Name', value: 'SubSiteId' }"
                :allowFiltering="true"
                :filtering="filteringDropdown"
                aria-label="Select School"
                placeholder="Select School"
                iconClass="app-icon-filter"
                :select="announceDropdownSelection"
                :created="() => setDropdownAriaLabel('chooseSchoolDropdown_hidden', 'Select School')"
            />
            <div class="print-display">{{ site }}</div>
        </div>
        <div class="meal-period-dropdown-container app-phone-full-width">
            <menu-dropdown
                id="chooseMealPeriodDropdown"
                cssClass="app-print-hide"
                :value="$store.state.PublicMenuModule.mealTimeId"
                :change="onMealTimeChange"
                :dataSource="mealTimes"
                :fields="{text: 'DisplayName', value: 'MealTimeId'}"
                aria-label="Select Meal Period"
                placeholder="Select Meal Period"
                iconClass="app-icon-filter"
                :created="() => setDropdownAriaLabel('chooseMealPeriodDropdown_hidden', 'Select Meal Period')"
            />
            <div class="print-display">{{ mealTime }}</div>
        </div>
    </div>
    
</template>
<script>
import adaMixin from '../js/mixins/adaMixin.js';
import MenuDropdown from './menuDropdown.vue';

export default {
    name: 'school-meal-filters',
    mixins: [ adaMixin ],
    components: { 'menu-dropdown': MenuDropdown },
    computed: {
        sites() {
            return this.$store.state.PublicMenuModule.sites;
        },
        mealTimes() {
            return this.$store.state.PublicMenuModule.mealTimes;
        },
        site() {
            const siteID = this.$store.state.PublicMenuModule.siteID;
            const selectedSite = this.sites.find(s => s.SubSiteId == siteID);
            return selectedSite ? selectedSite.Name : "";
        },
        mealTime() {
            const mealTimeId = this.$store.state.PublicMenuModule.mealTimeId;
            const selectedMealTime = this.mealTimes.find(m => m.MealTimeId == mealTimeId);
            return selectedMealTime ? selectedMealTime.DisplayName : "";
        }
    },
    methods: {
        onSiteChange(args) {
            const siteID = parseInt(args.value, 10);
            const selectedSite = this.sites.find(s => s.SubSiteId == siteID);

            if (selectedSite) {
                this.setAndClearAnnouncement(`School changed to ${selectedSite.Name}.`);
            }
            this.$store.dispatch('PublicMenuModule/setSiteID', siteID);
            this.setDropdownAriaLabel('chooseSchoolDropdown_hidden', 'Select School');
        },
        onMealTimeChange(args) {
            const mealTimeId = parseInt(args.value, 10);
            const selectedMealTime = this.mealTimes.find(m => m.MealTimeId == mealTimeId);
            if (selectedMealTime) {
                this.setAndClearAnnouncement(`Meal period changed to ${selectedMealTime.DisplayName}. Loading menu data.`);
            }
            this.$store.dispatch('PublicMenuModule/setMealTimeId', mealTimeId);
            this.setDropdownAriaLabel('chooseMealPeriodDropdown_hidden', 'Select Meal Period');
        }
    }
};
</script>
<style scoped>
.filters {
    flex: 1;
    display: flex;
    flex-direction: row;
    gap: 16px;
}

.school-dropdown-container {
    flex: 5;
}

.meal-period-dropdown-container {
    flex: 3;
}

.print-display {
    display: none;
    font-size: 20px;
    font-weight: 600;
}

@media print {
    .print-display {
        display: block;
    }
}

</style>